import { Component, OnInit, Input } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
	selector: 'ras-mini-banner',
	templateUrl: './mini-banner.component.html',
	styleUrls: ['./mini-banner.component.sass']
})
export class MiniBannerComponent implements OnInit {

	@Input() html: string;
	@Input() heading: string;
	@Input() picture: string[];
	@Input() top: string;
	@Input() bottom: string;
	@Input() colour: string;
	@Input() align: string | null = null;
	@Input() link?: string;
	@Input() icon?: string;

	safe_url(url: string) {
		return  this.sanitizer.bypassSecurityTrustUrl(url);
	}

	constructor(private sanitizer:DomSanitizer) { }

	ngOnInit(): void {
	}

}
